import { UserProject } from "../types/user.types";
import { Role } from "../types/role.types";

export const mapRoles = (userProjects: Array<UserProject>, roles?: Array<Role>): Array<Role> => {
  const result: Array<Role> = [];
  userProjects.forEach(project => {
    const find = roles?.find(item => item.id === project.roleId);
    if (!!find) {
      result.push(find);
    }
  });
  return result
}